import { IonSelectOption, IonSelect } from '@ionic/react';
import styled from 'styled-components';
import { AllieSelectProps } from './Select.types';

export const StyledSelectOption: any = styled(IonSelectOption)`
  color: var(--allie-color-neutral-70);
  --padding-start: 10px;
  --padding-end: 10px;
`;

export const StyledSelect: any = styled(IonSelect)<AllieSelectProps>`
  width: auto;
  background-color: ${(props: AllieSelectProps) =>
    `var(--allie-color-${props.color?.backgroundColor})`};
  color: ${(props: AllieSelectProps) => `var(--allie-color-${props.color?.allieColor})`};
  --padding-top: 10px;
  --padding-end: 15px;
  --padding-bottom: 10px;
  --padding-start: 15px;
  border-radius: 8px;
  border-color: var(--allie-color-light-40);
  border-style: solid;
  border-width: 1px;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  ${(props: AllieSelectProps) =>
    props.allieType === 'error' ? `border: 2px solid var(--allie-color-error-main);` : ''};
`;
